'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var backupLists = document.querySelectorAll('.backup-list');

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = backupLists[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var backLst = _step.value;

            $(backLst).on('select2:select', backupChanged);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    function backupChanged(event) {
        var selectedId = event.currentTarget.value;
        var selectedBackupLink = event.currentTarget.closest('.tab-pane').querySelector('.xml-selected-backup-download-link');
        selectedBackupLink.href = selectedBackupLink.href.replace(/&backupId=\d+$/, '&backupId=' + selectedId);
    }
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/Initializers/xmlFeedBackups.js
// module id = 413
// module chunks = 0